import { makeObservable, action } from 'mobx';
import { Tool, type ToolContext } from './base/Tool';
import type { DiamondElement, Element as CanvasElement } from '@/types';

export class DiamondTool extends Tool {
  constructor() {
    super('diamond', 'Diamond');
    makeObservable(this, {
      onStart: action,
      onMove: action,
      onEnd: action,
    });
  }

  onStart(context: ToolContext): CanvasElement | null {
    context.rootStore.uiStore.startDrawing(context.startPoint);
    return null;
  }

  onMove(context: ToolContext): CanvasElement | null {
    const { rootStore, currentPoint } = context;
    if (!rootStore.uiStore.isDrawing || !rootStore.uiStore.startPoint) {
      return null;
    }
    const bounds = this.getBounds({
      ...context,
      startPoint: rootStore.uiStore.startPoint,
      currentPoint,
    });
    if (bounds.width < 2 && bounds.height < 2) {
      return null;
    }
    return {
      id: this.generatePreviewId(),
      type: 'diamond',
      x: bounds.x,
      y: bounds.y,
      width: bounds.width,
      height: bounds.height,
      style: { ...context.persistentStyle },
      isSelected: false,
      zIndex: 0,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    } as DiamondElement;
  }

  onEnd(context: ToolContext): CanvasElement | null {
    const { rootStore, currentPoint } = context;
    const { uiStore, projectStore } = rootStore;
    if (!uiStore.isDrawing || !uiStore.startPoint) {
      return null;
    }
    const bounds = this.getBounds({
      ...context,
      startPoint: uiStore.startPoint,
      currentPoint,
    });

    if (bounds.width > 2 || bounds.height > 2) {
      projectStore.createElement({
        type: 'diamond',
        x: bounds.x,
        y: bounds.y,
        width: bounds.width,
        height: bounds.height,
        style: { ...uiStore.persistentStyle },
      } as any);
    }

    uiStore.endDrawing();
    uiStore.setActiveTool('select');
    return null;
  }

  getCursor(): string {
    return 'crosshair';
  }
}
